import React, { ComponentProps, PropsWithChildren, ReactNode } from "react"
import { createContext, Dispatch, useReducer } from "react"
import { ChartJSOrUndefined } from "react-chartjs-2/dist/types"
interface ContextState {
    isMultiAnno: boolean
    rangeAnni: number[]
    personeFisiche?: { anno: string; numeroPosizioni: string }[]
    societaPersone?: { anno: string; numeroPosizioni: string }[]
    societaCapitalientiNonCommerciali?: { anno: string; numeroPosizioni: string }[]
    totale?: { anno: string; numeroPosizioni: string }[]
    chartRefs?:ChartJSOrUndefined<"bar", number[], string>[] 
    NazionaliChartRefs?:ChartJSOrUndefined<"bar", number[], string>[] 
    chartRef?:ChartJSOrUndefined<"bar", number[], string>
}
interface ReducerAction {
    type:
        | "setMultiAnno"
        | "setChartRef"
        | "setPersoneFisiche"
        | "setSocietaPersone"
        | "setSocietaCapitali_EntiNonCommerciali"
        | "setTotale"
        | "setRangeAnni" | "setNazionaliChartRef"
    value: Partial<ContextState>
}

export const MultiAnnoContext = createContext<
    [ContextState, Dispatch<ReducerAction>]
>([{ isMultiAnno: false, rangeAnni: [] }, () => {}])

const MultiAnnoProvider = ({ children }: PropsWithChildren<ReactNode>) => {
    const [state, dispatch] = useReducer<
        (prevState: ContextState, action: ReducerAction) => ContextState,
        ContextState
    >(
        (prevState, action) => {
            switch (action.type) {
                case "setMultiAnno":
                    return {
                        ...prevState,
                        isMultiAnno: action.value.isMultiAnno ?? false
                    }
                case "setPersoneFisiche":
                    return {
                        ...prevState,
                        personeFisiche: action.value.personeFisiche
                    }
                
                case "setSocietaPersone":
                    return {
                        ...prevState,
                        societaPersone: action.value.societaPersone
                    }
                case "setSocietaCapitali_EntiNonCommerciali":
                    return {
                        ...prevState,
                        societaCapitalientiNonCommerciali: action.value.societaCapitalientiNonCommerciali
                    }
                case "setTotale":
                    return {
                        ...prevState,
                        totale: action.value.totale
                    }
                case "setChartRef":
                    
                    let array = prevState.chartRefs ?? [];
                    array?.push(action.value.chartRef)
                    
                    return {
                        ...prevState,
                        chartRefs: array
                    }
                case "setNazionaliChartRef":
                    
                     array = prevState.NazionaliChartRefs ?? [];
                    array?.push(action.value.chartRef)
                    
                    return {
                        ...prevState,
                        NazionaliChartRefs: array
                    }
                case "setRangeAnni":
                    return {
                        ...prevState,
                        rangeAnni: action.value.rangeAnni ?? []
                    }

                default:
                    return { ...prevState }
            }
        },
        {
            isMultiAnno: false,
            personeFisiche: undefined,
            rangeAnni: [],
            societaPersone: undefined,
            societaCapitalientiNonCommerciali: undefined,
            totale: undefined,
            chartRefs:[],
            NazionaliChartRefs:[]
        },
        () => ({
            isMultiAnno: false,
            personeFisiche: undefined,
            societaPersone: undefined,
            societaCapitalientiNonCommerciali: undefined,
            totale: undefined,
            chartRefs:[],
            NazionaliChartRefs:[],

            rangeAnni: []
        })
    )

    return (
        <MultiAnnoContext.Provider value={[state, dispatch]}>
            {children}
        </MultiAnnoContext.Provider>
    )
}

export default MultiAnnoProvider
